export default function Problems() {
  const problems = [
    {
      icon: 'ri-contrast-drop-2-line',
      text: 'エアコンのニオイが気になる',
    },
    {
      icon: 'ri-temp-cold-line',
      text: '効きが悪くなった',
    },
    {
      icon: 'ri-virus-line',
      text: '内部の汚れやカビが心配',
    },
    {
      icon: 'ri-question-line',
      text: '自分で掃除するのは不安',
    },
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-white to-cyan-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
          こんなお悩み<br className="md:hidden" />ありませんか？
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-cyan-100 rounded-full flex-shrink-0">
                  <i className={`${problem.icon} text-3xl text-cyan-600`}></i>
                </div>
                <p className="text-base font-normal text-gray-800 leading-relaxed">{problem.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-block bg-yellow-100 border-2 border-yellow-400 rounded-2xl px-8 py-4">
            <p className="text-lg md:text-xl font-bold text-gray-900">
              そのお悩み、プロのクリーニングで解決します！
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
